module.exports = __webpack_public_path__ + "assets/img/bg1.f6ef51a5.png";